import { Link } from "react-router-dom";
import { X, Check, Heart, ArrowRight } from "lucide-react";
import { Reveal } from "./motion";

const OTHERS = [
  "Just a regular plush",
  "No calming features",
  "Lightweight and flimsy",
  "Standard designs",
  "No night-time support",
  "Harder to keep clean",
  "Outgrown quickly",
];

const BUDDIES = [
  "Ultra-soft, premium plush",
  "Soothing, gentle glow",
  "Weighted arms for deeper hugs",
  "Adorable, unique characters",
  "Helps create a calming bedtime routine",
  "Durable & easy to clean",
  "A lifelong snuggle friend",
];

export default function CompareSection() {
  return (
    <section className="relative overflow-hidden px-4 py-10 sm:px-6 lg:py-14" data-testid="compare-section">
      <img src="/assets/compare-sky.png" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" />
      <div className="relative mx-auto max-w-3xl">
        <Reveal className="text-center">
          <p className="text-[11px] font-bold uppercase tracking-[0.35em] text-lavdeep">More than a stuffed animal</p>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-medium leading-[1.15] text-white sm:text-4xl">
            Why Bedtime Buddies Feel
            <span className="mt-2.5 inline-block rounded-full bg-moon px-5 py-1 text-navy">Different</span>
          </h2>
          <p className="mt-4 text-sm text-white/80">Designed for calmer nights, bigger hugs, and brighter tomorrows.</p>
        </Reveal>

        <Reveal delay={0.1} className="relative mt-10">
          <div className="grid gap-5 lg:grid-cols-2 lg:gap-14">
            <div className="rounded-[1.75rem] bg-white/10 p-6 backdrop-blur-md sm:p-7" data-testid="compare-others">
              <h3 className="text-center font-display text-xl font-medium text-white/85">Other Stuffed Animals</h3>
              <ul className="mt-5 space-y-2">
                {OTHERS.map((t) => (
                  <li key={t} className="flex items-center gap-3 rounded-full bg-white/10 px-4 py-2.5">
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/15 text-white/70"><X size={11} strokeWidth={3} /></span>
                    <span className="text-sm font-semibold text-white/75">{t}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative rounded-[1.75rem] bg-white p-6 shadow-[0_20px_50px_rgba(255,216,107,0.30)] sm:p-7" data-testid="compare-buddies">
              <span className="absolute -top-3.5 left-1/2 flex -translate-x-1/2 items-center gap-1.5 rounded-full bg-moon px-4 py-1 font-body text-[10px] font-extrabold uppercase tracking-widest text-navy">
                <Heart size={10} fill="#102A56" /> Bedtime Buddies
              </span>
              <h3 className="text-center font-display text-xl font-medium text-navy">Bedtime Buddies</h3>
              <ul className="mt-5 space-y-2">
                {BUDDIES.map((t) => (
                  <li key={t} className="flex items-center gap-3 rounded-full bg-moon/25 px-4 py-2.5">
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-moon text-navy"><Check size={11} strokeWidth={3.5} /></span>
                    <span className="text-sm font-semibold text-navy/80">{t}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <span className="absolute left-1/2 top-1/2 hidden h-12 w-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white font-display text-base font-medium text-navy shadow-xl lg:flex" aria-hidden="true">
            VS
          </span>
        </Reveal>

        <Reveal className="mt-9 text-center">
          <Link to="/buddy/luna-the-unicorn" data-testid="compare-cta"
            className="inline-flex items-center gap-2 rounded-full bg-pink px-9 py-3.5 font-body text-sm font-bold uppercase tracking-wide text-navy shadow-xl transition hover:scale-[1.04] hover:bg-moon">
            Meet the Buddies <ArrowRight size={16} />
          </Link>
          <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.3em] text-moon">♡ Happier nights. Brighter days.</p>
        </Reveal>
      </div>
    </section>
  );
}
